const UiTimePickerPropsOption = {
  classExtraName: { type: String, default: "" },
  placeholder: { type: Object, default: { start: "\u5F00\u59CB\u65F6\u95F4", end: "\u7ED3\u675F\u65F6\u95F4" } },
  modelValue: { type: Object, required: true },
  separator: { type: String, default: "\u81F3" },
  //* 中间分割
  zIndex: { type: Number, default: 66 },
  width: { type: [String, Number], default: 350 },
  mode: { type: String, default: "seconds" },
  name: { type: String, default: "" }
};
const UiTimePickerEmits = {
  "update:modelValue": (_ev) => true,
  "before-enter": () => true,
  "before-leave": () => true,
  "after-enter": () => true,
  "after-leave": () => true,
  "change": (_ev) => true
};

export { UiTimePickerEmits, UiTimePickerPropsOption };
//# sourceMappingURL=component.mjs.map
